import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';
import Input from './../../common/components/Input';
import Select from './../../common/components/Select';

class Form extends Component {
    static propTypes = {
        formValues: PropTypes.object,
        formErrors: PropTypes.object,
        formErrorMessages: PropTypes.object,
        handleUpdateFormValue: PropTypes.func,
        handleSaveElement: PropTypes.func,
        handleUpdateDayValue: PropTypes.func,
        handleCheckProperty: PropTypes.func,
        hideForm: PropTypes.func,
        isSavingForm: PropTypes.bool,
        isFetchingElement: PropTypes.bool
    };

    renderInput(label, name, type, required, colClass = 'col') {
        const { formValues, formErrors, handleUpdateFormValue, formErrorMessages } = this.props;
        return (
            <div className={colClass} key={name}>
                <label>{label} {required ? <span className="required">*</span> : null}</label>
                <Input
                    name={name}
                    required={required}
                    formValues={formValues}
                    formErrors={formErrors}
                    formErrorMessages={formErrorMessages}
                    handleUpdateFormValue={handleUpdateFormValue.bind(this, type, required)}
                />
            </div>
        );
    }

    renderSelect(label, name, options, required, colClass = 'col') {
        const { formValues, formErrors, handleUpdateFormValue } = this.props;
        return (
            <div className={colClass} key={name}>
                <label>{label} {required ? <span className="required">*</span> : null}</label>
                <Select
                    name={name}
                    required={required}
                    options={options}
                    formValues={formValues}
                    formErrors={formErrors}
                    handleUpdateFormValue={handleUpdateFormValue.bind(this, 'text', required)}
                />
            </div>
        );
    }

    render() {
        const { hideForm, handleSaveElement, isSavingForm, isFetchingElement, formValues } = this.props;

        let saveButtonLabel = 'Save';
        if (isSavingForm) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let form = (
            <form>
                <div className="row">
                    <div className="subtitle mt-0">Substrate Data</div>
                    <div className="w-100"></div>
                    {this.renderInput('Name', 'name', 'text', true)}
                    {this.renderSelect('Type', 'type', [{ label: 'Roll', value: 1 }, { label: 'Sheet', value: 2 }], true)}
                    <div className="w-100"></div>
                    {this.renderInput('Width (Inches)', 'width', 'decimal', true)}
                    {this.renderInput(formValues['type'] === 1 ? 'Height (Feet)' : 'Height (Inches)', 'length', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Attributes', 'attributes', 'text', true)}
                    {this.renderInput('Texture', 'texture', 'text', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Ink', 'ink', 'text', true)}
                    {this.renderInput('Application', 'application', 'text', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Thickness', 'thickness', 'text', true)}
                    {this.renderInput(formValues['type'] === 1 ? 'Cost per Roll' : 'Cost per Sheet', 'cost_each', 'decimal', true)}
                    <div className="w-100"></div>
                    {this.renderInput(formValues['type'] === 1 ? 'Cost per Linear Foot' : 'Cost per Square Foot', 'cost', 'decimal', true)}
                    {this.renderInput('Vendor', 'vendor', 'text', true)}
                    <div className="w-100"></div>
                    {this.renderInput('Markup', 'markup', 'text', true)}
                    {this.renderSelect('Active', 'is_active', [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }], true, 'col-6')}
                    <div className="w-100"></div>
                </div>
            </form>
        );
        if (isFetchingElement) {
            form = <div className="loading-data"><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button" onClick={handleSaveElement} disabled={isSavingForm}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideForm}>Close</button>
        ];
        return (
            <Dialog
                name="form"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{form}</div>
            </Dialog>
        );
    }
}

export default Form;
